module.exports = __webpack_public_path__ + "img/header-engagementRings.ecee288.webp";